export default {
  SET_TYPE: 'SET_TYPE',
  SET_ANSWER: 'SET_ANSWER',
  REMOVE_ANSWER: 'REMOVE_ANSWER'
};
